<template>
  <v-container>
    <v-row class="text-center">

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-10">
          Fittings
        </h1>

        <p class="subheading font-weight-regular">
          Below are some standard ways of fitting various ships.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-tabs fixed-tabs>

          <v-tab>
            Mrym - FOB
          </v-tab>
          <v-tab>
            Tengu - Logistics + Command
          </v-tab>
          <v-tab>
            Hyperion - Alpha Incursions
          </v-tab>
          <v-tab>
            Mach - Incursions Standard
          </v-tab>
          <v-tab-item>
          <div class="fitting">
            {{ myrmidonFitting }}
          </div>
          </v-tab-item>
          <v-tab-item>
          <div class="fitting">
          {{ tenguFitting }}
          </div>
          </v-tab-item>
          <v-tab-item>
          <div class="fitting">
            {{ hyperionFitting }}
          </div>
          </v-tab-item>
          <v-tab-item>
          <div class="fitting">
            {{ macharielFitting }}
          </div>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss" scoped>
  pre {
    font-size: small;
  }

  .fitting  {
    white-space: pre;
    padding-top: 0;
    padding-left: 25px;
    font-family: monospace;
    font-size: 14px;
  }
</style>
<script>

    import {fitting as tengu} from '@/assets/fittings/tengu-logi'
    import {fitting as hyperion} from '@/assets/fittings/hyperion-alpha'
    import {fitting as myrmidon} from '@/assets/fittings/myrmidon-fob'
    import {fitting as machariel} from '@/assets/fittings/machariel-incursions-standard'

    export default {
        name: 'Fittings',

        data: () => ({
            tenguFitting: tengu,
            hyperionFitting: hyperion,
            myrmidonFitting: myrmidon,
            macharielFitting: machariel,
        }),
    }
</script>
